import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { WrapLoading } from '../../../components/helpers/Loading'
import { useForm } from './_load/FormLoader'
import { useSaveFormReply } from './_requests/saveFormReply'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Image from '../../../components/presentation/Image'
import Link from '../../../components/actions/Link'
import Logo from '../../../components/shapes/Logo'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import { useColorableSpaceStyle } from '../../../packages/kiti/utils/styles/colorableSpace'

const Action = ({ onClick, icon, label, color }) => {
  const [, fontColor] = useColorableSpaceStyle({ color })

  return (
    <Link block onClick={onClick}>
      <IconText iconSize="1.4rem" weight="700" iconName={icon} color={fontColor} label={label} noWrap />
    </Link>
  )
}

const PageHeader = () => {
  const { t } = useTranslation('common')
  const [submit, { loading }] = useSaveFormReply()
  const form = useForm()

  return (
    <PageHeaderPanel
      titleContent={
        <div>
          {!!form?.logo ? (
            <Image maxHeight={`3.5rem`} width={`6.5rem`} src={form?.logo.src} alt="custom_logo" />
          ) : (
            <Logo white />
          )}
        </div>
      }
      smallPaddingTopBottom
      noContainer
      noWrap
      bgColor={form?.themeColor}
      side={
        <WrapLoading loading={loading} bgColor={COLORS.menu + '90'} color={COLORS.white}>
          <FlexGrid justify="flex-end" gutter={1}>
            <Action icon="BsCheckCircle" label={t('submit')} onClick={submit} color={form?.themeColor} />
          </FlexGrid>
        </WrapLoading>
      }
    />
  )
}

export default PageHeader
